import { Component, OnInit, Input, Optional, Inject } from "@angular/core";
import { GroupMaintenanceService } from "../group-maintenance.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { environment } from "src/environments/environment";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MediaObserver } from "@angular/flex-layout";
import { finalize } from "rxjs/operators";
import * as _ from "lodash";

@Component({
  selector: 'esc-grp-mnt-web-user-modal',
  templateUrl: './grp-mnt-web-user-modal.component.html',
  styleUrls: ['./grp-mnt-web-user-modal.component.scss']
})
export class GrpMntWebUserModalComponent implements OnInit {
  @Input() mode;
 
  public isDisabled;
  loading = {
    submit: false
  };
  webUserSelectorLabel = "LABEL_WEB_USER"

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    public languageService: LanguageService,
    private grpMntService: GroupMaintenanceService,
    public dialogRef: MatDialogRef<GrpMntWebUserModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
 
  public formGroup: FormGroup;
 
  ngOnInit() {
    this.initForm();
    // console.log(this.data);
  }
 
  initForm() {
    this.formGroup = this.fb.group({
      username: _.get(this, "data"),
 
      status: _.get(this.data, "is_active") == 1 ? true : false
    });
    
    this.toggleDisable();
  }
 
  toggleDisable() {
    if (!this.data.id) {
      this.formGroup.get("status").disable({ emitEvent: false });
      this.formGroup.get("status").setValue(true);
      this.isDisabled = false;
    } else {
      this.formGroup.get("username").disable({ emitEvent: false });
      this.isDisabled = true;
    }
  }

  webUserSelected(ev) {
    this.formGroup.get('username').setValue(ev);
  }
 
  saveChanges() {
    let loadingDialog = this.dialogService.loading();
    this.formGroup.disable();

    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.data, "user_mapping_id") || 0,
          user_recipient_id: _.get(this.formGroup.get("username"), "value") || [0],
          group_filter_id: _.toInteger(_.get(this.data, "group_filter_id") || 0),
          is_active: is_active
        }
      ]
    };

    this.grpMntService.upsertUser(obj).pipe(
      finalize(() => {
        loadingDialog.close();
        this.formGroup.enable();
        this.toggleDisable();
      })
    )
    .subscribe(
      (res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }

        if (_.has(res, 'status') && _.get(res, 'status') == 0) {
          this.helper.networkErrorMessage();
          return;
        }

        if(this.helper.displayErrorMessage(res)) return;

        if (_.get(res, 'success.count') > 0) {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
          this.close(true);
        }
      },
      err => {
        console.log(err);
      }
    );
  }
 
  close(data) {
    this.dialogRef.close(data);
  }
}